import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import { selectCurrentOrgId } from "features/store/orgSlice"
import { useRemoveOrgUserMutation } from "features/api"
import { buildGetErrorMessage, snackbarMutation } from "helpers/utils/mutations"
import ConfirmationPopup from "widgets/common/ConfirmationPopup"

interface RemoveUserModalProps {
  open: boolean
  onClose: () => void
  username: string
}

const RemoveUserModal = ({ open, onClose, username }: RemoveUserModalProps) => {
  const { t } = useTranslation()
  const orgId = useSelector(selectCurrentOrgId)

  const [removeUser, { isLoading: isDeleting }] = useRemoveOrgUserMutation()

  const handleRemoveUser = () => {
    snackbarMutation({
      mutation: removeUser({ username, orgId: orgId as number }).unwrap(),
      getErrorMessage: buildGetErrorMessage(
        t("error.DELETING_ITEM", { item: t("generic.USER") }),
      ),
      getSuccessMessage: () => t("users.USER_DELETED"),
    })
      .then(() => {
        onClose()
      })
      .catch(() => {})
  }

  return (
    <ConfirmationPopup
      open={open}
      onClose={onClose}
      description={t("users.ARE_YOU_SURE_TO_REMOVE_USER", { username })}
      mainButtonText={t("users.REMOVE_USER")}
      onConfirm={handleRemoveUser}
      isLoading={isDeleting}
      isDeletePopup
    />
  )
}

export default RemoveUserModal
